import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import OddsTable from '../Common/RCOddsTable';
import OddsDropLegend from '../Common/OddsDropLegend';
import PoolInvTable from '../Common/PoolInvTable';
import InvestmentCalculator from '../Common/InvestmentCalculator';
import JackpotAllocatedAmount from '../Common/JackpotAllocatedAmount';
import { getComingleMsgs, isStartSell, getIsShowPmuText, getUnComingle } from '../Common/Common';
import { RacingContext } from '../../Home/RacingPage';
import AddSlipBtn from '../Common/AddSlipBtn';
import ComingleMsg from '../Common/ComingleMsg';
import { MobileCurrentOdds } from '../Common/CurrentOdds';
import Loading from '../../Common/ui-components/Loading';
import ClearAllHorseSelectionsButton from '../Common/ClearAllHorseSelectionsButton';
import RaceSimResultBar from './RaceSimulator/RaceSimResultBar';

const OddsWP = (props) => {
    const context = useContext(RacingContext);

    const RCColumns = {
        alw: true,
        no: true,
        colour: true,
        horseName: true,
        rcNote: context.content.isPeNoteEnable,
        draw: true,
        wt: true,
        jocky: true,
        trainer: true,
        bodyWT: false,
        rtg: false,
        gear: false,
        last6: false,
        pwin0: false,
        pwin1: false,
        win: true,
        place: true,
        wp: true
    };



    if (context == null) {
        return  <Loading/>
    } else {

        return (
            <Content context={context} RCColumns={RCColumns}/>
        );
    }
}
export default OddsWP;

const Content = ({context, RCColumns}) => {
    if (context != null) {
        const mtg = context.content.meeting;
        const isShowPmu = getIsShowPmuText(mtg, context.content.raceNo)
        const isUnComingle =  getUnComingle(mtg, context.content.raceNo)
        let pageConfig = context.pageConfig;
        let betSlip
        if (pageConfig.showAddToSlip) {

            betSlip = (
                <div style={{marginTop: 6}} className={pageConfig.hiddenAddToSlip? "AddSlipBtn-Content hiddenAddSlip" : "AddSlipBtn-Content"}>
                    <div style={{display: 'flex'}}>
                        {window.globalConfig.enableHRClearAllSelectionButton && !context.windowSize.isMobileSize && (
                            <ClearAllHorseSelectionsButton />
                        )}
                        <AddSlipBtn />
                    </div>
                </div>
            );
        }
        return <section className={`${context.content.page} ${mtg.betType}`}>
            {
                (isShowPmu || isUnComingle) && <JackpotAllocatedAmount isUnComingle={isUnComingle}></JackpotAllocatedAmount>
            }
            <InvestmentCalculator enable={!context.windowSize.isMobileSize} />
            {!context.windowSize.isMobileSize && <MobileCurrentOdds /> }

            <div className='WP-RaceSimResultBar-wrap'>
                <RaceSimResultBar />
            </div>
            

            <OddsTable columns={RCColumns} />
            {
                isShowPmu  && !isStartSell(mtg) && <div className="rc-comingle-remarks"><ComingleMsg></ComingleMsg></div>
            }
            <OddsDropLegend />
            {context.windowSize.isMobileSize && <MobileCurrentOdds/>}
            <InvestmentCalculator className={`${context.windowSize.isMobileSize ? 'investment-calculator-drop-shadow border-radius-all' : ''}`} enable={context.windowSize.isMobileSize}  />
            <PoolInvTable />
            {
                isShowPmu && isStartSell(mtg) && <div className="rc-comingle-remarks"><ComingleMsg></ComingleMsg></div>
            }
            {betSlip}
            <InvestmentCalculator enable={!context.windowSize.isMobileSize}  />
        </section>

    }

}